import type { AgentCheckAnswer } from '@vd/types';
import { request } from '../../lib/apiClient';

/** What Toado saw of this person's agent reading `projectId` since `since` (TOADO-974). */
export function getAgentCheck(projectId: string, since?: string, signal?: AbortSignal): Promise<AgentCheckAnswer> {
  const query = new URLSearchParams({ projectId, ...(since ? { since } : {}) });
  return request<AgentCheckAnswer>(`/me/agent-check?${query.toString()}`, { method: 'GET', signal });
}

/**
 * What to ask the agent (TOADO-974): a read of one named project and nothing
 * more, so a check never creates, changes or starts anything, and never says
 * the agent may deploy.
 */
export function verificationPrompt(project: { id: string; name: string }): string {
  return `Using your Toado MCP connection, read the Toado project "${project.name}" (project id ${project.id}): list its columns and its five newest tickets. Only read. Do not create, change, move or comment on anything, and do not start work on any ticket.`;
}

/** How often the page asks while it waits, and for how long before it says nothing was seen. */
export const AGENT_CHECK_POLL_MS = 3_000;
export const AGENT_CHECK_WAIT_MS = 3 * 60_000;
